<script setup>
import { onBeforeUnmount, onMounted, watch } from "vue";

const props = defineProps({
    value: {
        type: String,
    },
    name: {
        type: String,
    },
});

let initialContent = null;
let meta = null;

onMounted(() => {
    meta = document.querySelector(`meta[name="${props.name}"]`);

    if (meta) {
        initialContent = meta.getAttribute('content');
    } else {
        meta = document.createElement('meta');
        meta.setAttribute('name', props.name);
        document.head.appendChild(meta);
    }

    meta.setAttribute('content', props.value);
});

onBeforeUnmount(() => {
    if (initialContent) {
        meta.setAttribute('content', initialContent);
    }
});

watch(() => props.value, (value) => {
    meta?.setAttribute('content', value);
});
</script>

<template>
</template>
